import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom';
import App from '@/App';
import { AppSetup } from '@/AppSetup';
import AppLayout from './app-layout';
import Dashboard from '@/Pages/Dashboard/Dashboard';
import Places from './places.routes';
import Events from './events.routes';
import Fares from './fares.routes';
import { ROLE_TYPES } from '@/Interfaces/Data';
import { AuthorizationOutlet } from './utils/authorization-outlet';
import { StageOnlyOutlet } from './utils/stage-only-outlet';
import Members from './members.routes';
import MotoboysRoutes from './motoboys.routes';
import PreCadastroRoutes from './precadastro.routes';
import DeliveriesRoutes from './deliveries.routes';
import Missions from './missions.routes';
import { NotFound } from '@/_components/not-found/not-found';
import MonitorDeliveries from '@/Pages/monitor-deliveries';
import { DELIVERY_LIST_PERMISSION_KEYS } from '@/_constants/permissions';
import { MONITOR_DELIVERIES_PERMISSIONS } from '@/_features/monitor-deliveries/constants';

export const ROUTER = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<AppSetup />}>
      <Route element={<App />}>
        <Route element={<AppLayout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="inicio" element={<Dashboard />} />
          <Route
            element={
              <AuthorizationOutlet
                permissions={MONITOR_DELIVERIES_PERMISSIONS}
                permissionKeys={DELIVERY_LIST_PERMISSION_KEYS}
              />
            }
          >
            <Route element={<StageOnlyOutlet />}>
              <Route path="monitor-entregas" element={<MonitorDeliveries />} />
            </Route>
          </Route>
          <Route path="entregas/*" element={<DeliveriesRoutes />} />
          <Route path="entregadores/*" element={<MotoboysRoutes />} />
          <Route path="precadastro/*" element={<PreCadastroRoutes />} />
          <Route path="estabelecimentos/*" element={<Places />} />
          <Route
            element={<AuthorizationOutlet permissions={[ROLE_TYPES.ADMIN]} />}
          >
            <Route path="equipe/*" element={<Members />} />
          </Route>
          <Route path="eventos/*" element={<Events />} />
          <Route
            element={
              <AuthorizationOutlet
                permissions={[
                  ROLE_TYPES.ADMIN,
                  ROLE_TYPES.SUPPORT,
                  ROLE_TYPES.LOGISTIC_OPERATOR,
                ]}
              />
            }
          >
            <Route path="tarifas/*" element={<Fares />} />
          </Route>
          <Route
            element={
              <AuthorizationOutlet
                permissions={[ROLE_TYPES.ADMIN, ROLE_TYPES.SUPPORT]}
              />
            }
          >
            <Route path="missoes/*" element={<Missions />} />
          </Route>
        </Route>
        <Route path="not-found" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Route>,
  ),
);
